export default __webpack_public_path__ + "locales/sl/Files.json?hash=9ec2717d2bfadd7bc210f886ff0933cf";